module.exports = __webpack_public_path__ + "static/go-burguer-hamburguer-bacon-cheddar-bg-9578fed92e37a03cba002457afc559c2.jpg";